<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div
      v-for="item in safe"
      :key="item.id"
      :class="{'bg':item.hasBg}"
    >
      <div class="costs">
        <p class="sub_title">
          {{ item.title }}
        </p>
        <div class="content_S">
          <div>
            {{ item.content }}
          </div>
          <div v-if="item.hasBox">
            <div class="framework">
              <div
                v-for="list in item.steps"
                :key="list"
                class="step"
              >
                <div class="top">
                  {{ list.top }}
                </div>
                <div
                  v-for="tip in list.tips"
                  :key="tip.id"
                  class="tip"
                >
                  {{ tip }}
                </div>
                <div class="number">
                  {{ list.number }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="item.hasImg"
            class="hasImg"
          >
            <img
              src="@/assets/solution/safeOperationSolution/steps.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FullFlowSafety',
  data() {
    return {
      title: '安全运营体系介绍',
      subtitle: '灵创科技为了解决安全产品只能实现标准化的静态、被动防御，从客户实际需求出发提出了独有的网络安全运营服务体系，通过“人+流程+数据+平台”构建可持续安全监测和响应能力。同时，通过设置专业的技术人员岗位，明确岗位职责，制定标准工作流程及规范协同机制，实现网络安全防护的最终目标，满足客户各个场景的需求，以达到信息系统“有事件，无事故”目的。',
      safe: [
        {
          id: 1,
          title: '安全运营核心思想',
          content: '安全运营服务通过“人+流程+数据+平台”，调动一切的积极因素，把网络安全平台、设备、技术团队、流程等统筹起来，并不断的运用、改进以适应客户信息系统的安全防护需求。'
        },
        {
          id: 2,
          title: '安全运营架构',
          content: '灵创科技依据单位网络与业务信息系统安全运营服务要求，贯彻“以人员为核心、以数据为基础、以运营为手段”的基本安全理念，结合单位网络与业务信息系统实际情况，提供全方位网络信息安全保障形成一个完善合理的安全运营架构。',
          hasBox: 'true',
          hasBg: true,
          steps: [
            {
              id: 4,
              top: '安全运营管理',
              tips: ['安全组织管理建设', '安全管理制度体系'],
              number: '01'
            },
            {
              id: 5,
              top: '安全运营流程',
              tips: ['知己、知彼、分析加固', '事件处理'],
              number: '02'
            },
            {
              id: 6,
              top: '安全运营平台',
              tips: ['空间资产测绘平台', '态势感知平台', '安全运营管理中心', '应急工具箱', '教培平台'],
              number: '03'

            }
          ]
        },
        {
          id: 3,
          title: '安全运营流程体系',
          content: '安全运营本质是调动一切的积极因素，把网络安全平台，设备，队伍，流程等统筹起来，并不断的运用、持续改进的动态过程安全运营真个服务过程可以分为三个阶段，总共包含五个步骤',
          hasImg: 'true'
        }
      ]

    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 56%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 76%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }

  .costs {
    width: 100%;
    padding-top: 78px;
    padding-bottom: 100px;

    .sub_title {
      margin-bottom: 75px;
    }

    .content_S {
      width: 70%;
      margin: 0 auto;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 40px;

      .framework {
        width: 100%;
        display: flex;
        margin-top: 120px;
        justify-content: space-between;

        .step {
          width: 32%;
          height: 460px;
          background: #FAFAFA;
          box-shadow: 0px 0px 16px 4px #D2DDFC;
          position: relative;

          &:nth-child(2) {
            background: rgba(69, 89, 233, 0.5);

            .top {
              color: #ffffff;
            }

            .tip {
              color: #ffffff;
            }
          }

          .top {
            height: 24px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            text-align: center;
            margin: 62px 0 47px;
          }

          .tip {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            text-align: center;
          }

          .number {
            font-size: 100px;
            font-family: DIN;
            font-weight: bold;
            color: #4559E9;
            position: absolute;
            bottom: 36px;
            left: 35%;
          }
        }
      }

      .hasImg {
        width: 100%;
        height: 450px;
        margin-top: 48px;

        img {
          width: 95%;
        }
      }
    }
  }

  .bg {

    background: #FAFBFF;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px){
   .banner .banner_Title .subtitle ,
   .page_html .costs .content_S{
    font-size: 20px !important;
  }

   .banner .banner_Title .title {
    width: 100%;
    font-size: 37px !important;
  }

  .banner{
    height: 400px !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px){
  .page_html .banner .banner_Title .title {
    width: 95%;
    font-size: 40px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner{
    height: 450px !important;
  }
  .page_html .costs .content_S{
    font-size: 22px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
  .page_html .banner .banner_Title .subtitle {
    font-size: 30px;
  }
  .banner .banner_Title .title {

    font-size: 52px !important;
  }

}
</style>
